import { render, staticRenderFns } from "./video_9.vue?vue&type=template&id=2cc10af4&scoped=true&"
var script = {}
import style0 from "./video_9.vue?vue&type=style&index=0&id=2cc10af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc10af4",
  null
  
)

export default component.exports